import { type AwardCriterionWeightDto, WeightType } from "../../../../../autogen/bff-api";

export const formatYesNo = (
  value: boolean | null | undefined,
  t: (key: string) => string,
): string | null => {
  if (value == null) return null;
  return value ? t("Yes") : t("No");
};

export const formatWeight = (
  weight: AwardCriterionWeightDto | null | undefined,
): string | null => {
  if (!weight) return null;
  if (weight.type === WeightType.Percentage) return `${weight.number}%`;
  return `${weight.number}`;
};
